import { tenantIDAtom } from "atoms/GlobalAtoms";
import { activeLinkAtom } from "atoms/SidebarAtoms";
import useCloudPermissions from "hooks/useCloudPermissions";
import { useAtom, useAtomValue } from "jotai";
import React from "react";
import CollapseIconLink from "../CollapseIconLink";

const getSettings = (tenantID, cPermissions) => [
  {
    name: "Cloud Tags",
    path: `/clouds/${tenantID}/settings/tags`,
    icon: "mdi mdi-tag-multiple",
  },
  {
    name: "Security & Access",
    path: `/clouds/${tenantID}/settings/security-access/users`,
    icon: "mdi mdi-shield-account",
    disabled: !cPermissions.cloud_get_credentials,
  },
  {
    name: "All Data Sources",
    path: `/clouds/${tenantID}/settings/modules`,
    icon: "mdi mdi-database-cog-outline",
    disabled: !cPermissions.cloud_modify_module,
  },
  {
    name: "API Keys",
    path: `/clouds/${tenantID}/settings/api-keys`,
    icon: "mdi mdi-api",
    disabled: !cPermissions.cloud_get_credentials,
  },
  {
    name: "Cloud Backups",
    path: `/clouds/${tenantID}/settings/backup/main`,
    icon: "mdi mdi-database-sync",
    disabled: !cPermissions.cloud_get_credentials,
  },
  {
    name: "Workflows",
    path: `/clouds/${tenantID}/workflows`,
    icon: "mdi mdi-sitemap",
    disabled: false,
  },
];

const CRMSettingsLinks = ({ open }) => {
  const { cPermissions } = useCloudPermissions();
  const [activeLink, setActiveLink] = useAtom(activeLinkAtom);
  const tenantID = useAtomValue(tenantIDAtom);

  return (
    <CollapseIconLink
      item={{
        icon: "mdi mdi-cog",
        name: "Cloud Settings",
        children: getSettings(tenantID, cPermissions),
      }}
      type="Direct"
      bold={false}
      sidebarOpen={open}
      activeLink={activeLink}
      setActiveLink={setActiveLink}
    />
  );
};

export default CRMSettingsLinks;
